module.exports = __webpack_public_path__ + "media/our_mission/OurValues_en-faa5cd32.webp";